import { useState, useEffect, useRef } from 'react'
import { Search, X } from 'lucide-react'
import { useDebounce } from '@/lib/utils'

interface TableSearchProps {
  onSearch: (value: string) => void
  placeholder?: string
}

export function TableSearch({ onSearch, placeholder = 'Search...' }: TableSearchProps) {
  const [value, setValue] = useState('')
  const debounced = useDebounce(value, 300)
  const onSearchRef = useRef(onSearch)
  onSearchRef.current = onSearch

  useEffect(() => {
    onSearchRef.current(debounced)
  }, [debounced])

  return (
    <div className="relative flex items-center flex-1 group">
      <Search
        size={13}
        className="absolute left-3 text-slate-400 dark:text-slate-500 shrink-0 pointer-events-none z-10"
      />
      <input
        type="text"
        className="
          w-full h-9 pl-8 pr-8 text-sm rounded-xl
          bg-slate-50 dark:bg-slate-700/50
          border border-slate-200 dark:border-slate-600/60
          text-foreground placeholder:text-slate-400 dark:placeholder:text-slate-500
          focus:outline-none focus:ring-2 focus:ring-[#076698]/30 focus:border-[#076698]/60
          transition-colors
        "
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      {value && (
        <button
          type="button"
          onClick={() => setValue('')}
          className="absolute right-2.5 text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
          aria-label="Clear search"
        >
          <X size={13} />
        </button>
      )}
    </div>
  )
}
